import ReactGA from 'react-ga';

let gaInitialized = false;

export const isGaEnabled = () => gaInitialized;

export function initGA(): void {
	if (process.env.REACT_APP_GA_TRACKING_CODE) {
		ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_CODE, {
			debug: false,
		});
		gaInitialized = true;
	}
}
